export default class ReadMore {
    public static init(): void {
        this.handleLinks();
    }

    static handleLinks(): void {
        const links = document.querySelectorAll('[data-read-more-link]');
        links.forEach((link) => {
            const targetSelector = link.getAttribute('data-read-more-link');
            if (!targetSelector) return;

            const targetElements = document.querySelectorAll(targetSelector) as NodeListOf<HTMLDivElement>;
            targetElements.forEach((targetElement) => {
                // Kontrola přetečení obsahu a inicializace viditelnosti tlačítka
                if (targetElement.scrollHeight > targetElement.clientHeight && targetElement.dataset.readMoreInitialized !== 'true') {
                    targetElement.dataset.readMoreInitialized = 'true';
                }

                const isContentOverflowing = targetElement.scrollHeight > targetElement.clientHeight;
                link.classList.toggle('d-none', !isContentOverflowing && targetElement.dataset.readMoreInitialized !== 'true');

                // Přidání třídy limit-text-to-3-lines na začátku, pokud je obsah přetečený
                if (isContentOverflowing) {
                    targetElement.querySelectorAll('p').forEach(p => {
                        p.classList.add('limit-text-to-3-lines');
                    });
                }

                // Inicializace posluchače kliknutí pouze jednou
                if (link.getAttribute('data-initialized') !== 'true') {
                    link.setAttribute('data-initialized', 'true');
                    link.addEventListener('click', () => {
                        this.toggleReadMore(targetElement, link);
                    });
                }
            });
        });
    }

    static toggleReadMore(targetElement: Element, link: Element) {
        const textBefore = link.getAttribute('data-read-more-before');
        const textAfter = link.getAttribute('data-read-more-after');
        if (!textBefore || !textAfter) {
            console.error('Missing "data-read-more-before" or "data-read-more-after" attribute.');
            return;
        }

        // Změna stavu viditelnosti a aktualizace textu tlačítka
        const isCurrentlyVisible = targetElement.getAttribute('data-read-more') === 'visible';
        targetElement.setAttribute('data-read-more', isCurrentlyVisible ? 'hidden' : 'visible');
        link.textContent = isCurrentlyVisible ? textBefore : textAfter;

        // Správná aktualizace třídy na p tagy
        this.updatePtags(targetElement, isCurrentlyVisible);
    }

    static updatePtags(targetElement: Element, isHidden: boolean) {
        const pTags = targetElement.querySelectorAll('p');
        pTags.forEach(p => {
            p.classList.toggle('limit-text-to-3-lines', isHidden);
        });
    }
}

(window as any).ReadMore = ReadMore;
